import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export default function Register() {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    loginWithRedirect({
      appState: { returnTo: "/onboarding" },
      authorizationParams: {
        screen_hint: "signup",
        audience: "https://someet-api",
      },
    });
  }, [loginWithRedirect]);

  return null;
}
//   useEffect(() => {
//     loginWithRedirect({ authorizationParams: { screen_hint: "signup" } });
//   }, [loginWithRedirect]);
// }